<div class="overLayDiv active"></div>
<div id="rightSideBar">
    <div class="rightSidePanel d-flex flex-column">
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <h2>{{ 'info' | translate }}</h2>
            </div>            
        </header>
        <div class="eod-panel-body-with-footer">
            <div class="block mt-2">
                <h6 class="info-text">
                    <i class="fas fa-info-circle"></i>
                    <span>{{ 'mileage_location_info_panel_1' | translate }}</span>
                </h6>
                <h6 class="info-text">
                    <i class="fas fa-info-circle"></i>
                    <span>{{ 'mileage_location_info_panel_2' | translate }}</span>
                </h6>
                <h6 class="info-text mb-0 pb-0 border-0">
                    <i class="fas fa-info-circle"></i>
                    <span>{{ 'mileage_location_info_panel_3' | translate }}</span>
                </h6>
                <h6 class="info-text pl-3 mb-0 pb-0 border-0">
                    <i class="fas fa-circle f-10 eod-text-primary"></i>
                    <span>{{ 'mileage_location_info_panel_4' | translate }}</span>
                </h6>
                <h6 class="info-text mb-0 pb-0 border-0 pl-3">
                    <i class="fas fa-circle f-10 eod-text-primary"></i>
                    <span>{{ 'set' | translate }} <b>{{ 'location' | translate }}</b> {{ 'label_to' | translate }} <b>{{ 'label_allow' | translate }}</b></span>
                </h6>
            </div>
        </div>
        <footer class="mt-auto py-1 d-flex justify-content-center align-items-center gap-2 height-60px">
            <button type="button" class="btn eod-btn-outline-warning" (click) = "closePanel()">
                {{'close' | translate }}
            </button>
        </footer>
    </div>
</div>